import { LuFileText, LuMic } from "react-icons/lu";

// Merlin functions for video/audio boxes: Transcribe + Narration Voice
// ("Anlatım Sesi" — opens the normal AI voice sound modal pre-filled with the
// transcript). `name` is an i18n key resolved by MerlinFeaturesPanel via
// i18n.t(feature.name).
export const VIDEO_AUDIO_FEATURES = [
  { id: "transcribe", name: "MerlinVideoTranscribe", icon: LuFileText },
  { id: "narration", name: "NarrationSound", icon: LuMic },
];
